export const byDefined = <Type>(value: Type | undefined): value is Type => {
  return value !== undefined;
};

export const byDefinedKeys =
  <Type, Key extends keyof Type>(...keys: Key[]) =>
  (value: Type): value is { [K in Key]-?: NonNullable<Type[K]> } & Type => {
    return keys.every(key => value[key] !== undefined);
  };
